import './translate-component.sass';
import { useState, useEffect } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import { i18n } from 'i18next';

const languages = [
  {
    code: 'en',
    name: 'English',
    flag: (
      <ReactCountryFlag style={{ fontSize: '25px' }} countryCode="GB" svg />
    ),
  },
  {
    code: 'fr',
    name: 'Français',
    flag: (
      <ReactCountryFlag style={{ fontSize: '25px' }} countryCode="FR" svg />
    ),
  },
  {
    code: 'nl',
    name: 'Nederlands',
    flag: (
      <ReactCountryFlag style={{ fontSize: '25px' }} countryCode="NL" svg />
    ),
  },
];

const getDefaultLang = (i18n: i18n) => {
  const savedLang = i18n.language.split('-')[0].toLowerCase();
  return languages.find((lang) => lang.code === savedLang) || languages[0];
};

const TranslateComponent = () => {
  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(() => getDefaultLang(i18n));

  useEffect(() => {
    setSelectedLang(getDefaultLang(i18n));
  }, [i18n.language]);

  const handleSelect = async (code: string) => {
    try {
      await i18n.changeLanguage(code);
      window.location.reload();
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  return (
    <div className="language-select">
      <Dropdown className="language-dropdown">
        <DropdownToggle variant="light" className="dropdown-toggle">
          {selectedLang.flag}
        </DropdownToggle>
        <DropdownMenu>
          {languages.map((lang) => (
            <DropdownItem
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
            >
              {lang.flag} {lang.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export { TranslateComponent };
